/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobAdGenerationTemplate } from './job-ad-generation-template';
import { JobAdGenerationJobAd } from './job-ad-generation-job-ad';

export interface JobAdGenerationTemplateStatus {
  languageCode?: string | null;
  state?: JobAdGenerationTemplateStatusStateEnum;
  threadId?: string | null;
  template?: JobAdGenerationTemplate;
  jobAd?: JobAdGenerationJobAd;
  failureReason?: string | null;
}
export enum JobAdGenerationTemplateStatusStateEnum {
  Pending = 'Pending',
  Generating = 'Generating',
  Done = 'Done',
  Failed = 'Failed',
  Outdated = 'Outdated'
}
